import { useEffect } from 'react';

export default (filterMap, positions, setFilteredPositions, filteredDevices) => {
  useEffect(() => {
    setFilteredPositions(filterMap
      ? filteredDevices.map((device) => positions[device.id]).filter(Boolean)
      : Object.values(positions));
  }, [filterMap, positions, setFilteredPositions, filteredDevices]);
};
